<template>
    <div>
        <div class="container">
      <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Bank Masr Payment Status</a></h1>
  
  <div class="row">
  <div class="col-md-12">
  <div class="panal mt-20">
  <div class="panal-header">Payment Status </div>
  <div class="panal-body " >
     
          <p class="mt-50 alert alert-success text-center">  Your Payment Is Successfully </p>
     
      </div>
  
  
    
      
    </div>
  </div>
  </div>
        </div>
    </div>
    
  </template>

<script>
export default {
  name: 'BMPaymentSuccess',

  mounted() {
    // Redirect after 5 seconds
    setTimeout(() => {
      // If using Vue Router
      this.$router.push('/Wallet'); // Change to your target route

      // If not using Vue Router, use window.location.href
      // window.location.href = 'http://example.com'; // Change to your target URL
    }, 5000); // 5000 milliseconds = 5 seconds
  },
}
</script>

<style>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}
.mt-50{
    margin-top: 50px !important;
}
.m-auto{
    margin: auto !important;
}

#overlay{
  position: unset !important;
}
</style>